export function getArcPortalRoot(): HTMLElement | undefined {
  if (typeof document === "undefined") return undefined
  let root = document.querySelector<HTMLElement>("[data-danaro-arc-portal]")
  if (!root) {
    root = document.createElement("div")
    root.className = "danaro-arc-portal"
    root.dataset.danaroArcPortal = ""
    root.dataset.accent = "neutral"
    root.dataset.theme = document.documentElement.classList.contains("dark") ? "dark" : "light"
    document.body.append(root)
  }
  return root
}
